import { render } from "./RegTeamOnEvent.vue?vue&type=template&id=51d3bbb1&scoped=true"
import script from "./RegTeamOnEvent.vue?vue&type=script&lang=js"
export * from "./RegTeamOnEvent.vue?vue&type=script&lang=js"

import "./RegTeamOnEvent.vue?vue&type=style&index=0&id=51d3bbb1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d3bbb1"]])

export default __exports__